import {assert} from 'Asserts';

export default function switchPanes(paneOrder, {currentPaneKey, excludedPanes, offset}) {
  const panes = paneOrder.filter((paneKey) => !excludedPanes.includes(paneKey));

  const paneIndex = panes.findIndex((paneKey) => paneKey === currentPaneKey);
  assert(paneIndex !== -1, `Invalid pane "${currentPaneKey}"`);

  const newPaneIndex = paneIndex + offset;
  assert(newPaneIndex >= 0, 'Cannot go before first pane');
  assert(newPaneIndex < panes.length, 'Cannot go past last pane');
  return panes[newPaneIndex];
}
